export default class DelProductItem extends HTMLButtonElement {
    constructor() {
        super();
    }

    connectedCallback() {
        $(this).on('click', function (e) {
            this.delProductItem();
            let productAddButton = document.querySelector('button[name^="add-product-button"]');
            productAddButton.style = 'display: block';
        });
    }

    delProductItem() {
        $(this).parents('.product-item-block').remove();
    }
}
